import { Theme } from '@mui/material';
import { Colors } from '@sweatpals/react-ui-kit';

export const upgradeTicketFormStyles = (theme: Theme) => ({
	root: {
		position: 'relative',
		backgroundColor: Colors['1A1A1A'],
		height: '100%',

		'*::-webkit-scrollbar': {
			width: '4px',
		},

		'*::-webkit-scrollbar-thumb': {
			borderRadius: '2px',
			backgroundColor: Colors.white_a70,
		}
	},
	content: {
		position: 'relative',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		px: { xs: '16px', sm: '64px' },
		py: { xs: '30px', sm: '32px' },
	},
	body: {
		p: { xs: '16px 0 0 0', md: '35px 35px 0 35px' },
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		overflow: 'hidden',
		mx: 'auto',
		maxWidth: { sm: '560px', md: '940px' },
		width: '100%',
	},
	formBody: {
		display: 'flex',
		overflow: { xs: 'auto', md: 'hidden' },
		flexDirection: { xs: 'column', md: 'row' },
		gap: '16px',
	},
	placeholder: {
		maxWidth: '377px',
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		gap: '32px',
	},
	placeholderIcon: {
		fontFamily: 'Integral CF, sans-serif',
		fontSize: '40px',
		fontWeight: 500,
		lineHeight: '30px',
		textAlign: 'center',
	},
	placeholderTitle: {
		color: Colors.white,
		fontFamily: 'Montserrat',
		fontSize: '18px',
		fontWeight: 700,
		lineHeight: 'normal',
		textAlign: 'center',
	},
	placeholderDescription: {
		color: Colors['C5C5C5'],
		fontFamily: 'Montserrat',
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: 'normal',
		textAlign: 'center',
	},
	viewTicketsButton: {
		fontFamily: 'Montserrat',
		fontSize: '13px',
		fontWeight: 700,
		lineHeight: '120%',
		backgroundColor: Colors['343434'],
		borderColor: Colors.white_a10,
		padding: '10px 12px',
	},
	eventInfo: {
		p: '24px',
		gap: '27px',
		display: 'flex',
		position: 'relative',
		backgroundColor: Colors.black_a40,
		alignItems: 'center',

		'&:before': {
			content: '""',
			position: 'absolute',
			inset: 0,
			borderRadius: '8px 8px 0 0',
			border: '2px solid transparent',
			background: 'linear-gradient(162.26deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 91.05%) border-box',
			mask: 'linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)',
			maskComposite: 'exclude',
			pointerEvents: 'none',
		}
	},
	eventBackground: {
		minWidth: '70px',
		maxWidth: '70px',
		minHeight: '70px',
		maxHeight: '70px',
		borderRadius: '4px',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'center',
		backgroundSize: 'cover',
	},
	orderSummary: {
		padding: '24px 12px',
		borderRadius: '0 0 8px 8px',
		backgroundColor: Colors.black_a30,
		position: 'relative',
		userSelect: 'none',
		overflow: 'hidden',
		flex: '0 1 auto',
	},
	eventName: {
		fontFamily: 'Montserrat',
		fontSize: '16px',
		fontWeight: 700,
		lineHeight: '24px',
		color: Colors.white,
	},
	loader: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	eventDate: {
		flex: 1,
		color: Colors.white_a80,
		fontFamily: 'General Sans, sans-serif',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '18px',
	},
	form: {
		borderRadius: '8px',
		backgroundColor: Colors.black_a50,
		p: { xs: '16px', ms: '24px' },
		display: 'flex',
		flexDirection: 'column',
		gap: '32px',
	},
	title: {
		fontFamily: 'Integral CF, sans-serif',
		fontSize: '16px',
		fontWeight: 600,
		lineHeight: '19px',
		color: Colors.white,
	},
	description: {
		color: Colors.white,
		fontFamily: 'Montserrat',
		fontSize: '14px',
		fontWeight: 500,
	},
	price: {
		display: 'flex',
		flexDirection: 'column',
		gap: '10px',
		color: Colors.white,
	},
	priceTitle: {
		fontFamily: 'Montserrat',
		fontSize: '15px',
		fontWeight: 700,
		lineHeight: '21px',
	},
	priceInfo: {
		padding: '16px',
		display: 'flex',
		alignItems: 'center',
		gap: '10px',
		borderRadius: '8px',
		backgroundColor: Colors.white_a5,

		'& svg': {
			width: '20px',
			height: '20px',
		}
	},
	priceName: {
		fontFamily: 'Montserrat',
		fontSize: '15px',
		fontWeight: 700,
		lineHeight: 'normal',
	},
	priceDescription: {
		color: Colors.white_a90,
		fontFamily: 'Montserrat',
		fontSize: '13px',
		fontWeight: 500,
		lineHeight: '21px',
	},
	priceAmount: {
		textAlign: 'center',
		fontFamily: 'Montserrat',
		fontSize: '15px',
		fontWeight: 700,
		lineHeight: 'normal',
	},
	pricesSelectPaper: {
		'& .MuiList-root': {
			backgroundColor: Colors['1E1E1E'],

			'& .MuiMenuItem-root': {
				backgroundColor: 'transparent',
				gap: '10px',
				p: '8px 12px',
				border: `1px solid ${Colors.white_a5}`,

				'&.Mui-selected': {
					backgroundColor: 'transparent'
				},

				'&:hover': {
					backgroundColor: Colors.white_a10,
				},
			},
		},
	},
	pricesSelectItem: {
		flexDirection: 'column',
		alignItems: 'unset',
	},
	priceSelectItemTitle: {
		fontFamily: 'Montserrat',
		fontSize: '16px',
		fontWeight: 700,
		lineHeight: '24px',
	},
	priceSelectItemDescription: {
		color: Colors.white_a80,
		fontFamily: 'Montserrat',
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: '120%',
	},
	submitButton: {
		height: '50px',
		minWidth: '132px',
		borderRadius: '100px',
		color: Colors.black,
		fontWeight: 500,
		fontSize: '12px',
		lineHeight: '14px',
		fontFamily: 'Integral CF, sans-serif',
		textTransform: 'uppercase',
		p: '10px 32px',
		backgroundColor: Colors.white,

		'&:hover': {
			backgroundColor: Colors.black,
			color: Colors.white,
		},

		'&:active': {
			backgroundColor: Colors.black,
			color: Colors.white,
		},
	},
});
